import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submitButton"]
  
  connect() {
    this.inputTarget.focus()
  }

  formatInput(event) {
    let value = event.target.value.toUpperCase()
    // Remove any characters that aren't alphanumeric
    value = value.replace(/[^A-Z0-9]/g, '')
    // Limit to 8 characters
    value = value.substring(0, 8)
    
    event.target.value = value
    
    // Enable/disable submit button based on length
    this.submitButtonTarget.disabled = value.length !== 8
  }
}